import { useCatalogStore } from '../catalog'
import { ICruise } from '../catalog/interfaces'
import { mapCruiseToGrid } from './helper.js'
import { IMapCruiseGridResult } from './interfaces'

export const cruiseList = (): IMapCruiseGridResult[] => {
  const catalogStore = useCatalogStore()
  const cruises: ICruise[] = catalogStore.cruises
  const cruiseListCount = cruises.length
  
  if (!cruiseListCount) {
    return []
  }

  const cruiseList: IMapCruiseGridResult[] = new Array(cruiseListCount)

  for (let i = 0; i < cruiseListCount; ++i) {
    cruiseList[i] = mapCruiseToGrid(cruises[i])
  }

  return cruiseList
}

export default {
  cruiseList,
}
